import React, {useRef} from "react";

import "./FileUploadButton.css";
import {StandardButton} from "../standard-button/StandardButton";

export const FileUploadButton = ({setFile, disableButton, buttonText}) => {

    const fileInputRef = useRef();

    const handleButtonClick = () => {
        fileInputRef.current.click();
    }

    const handleFileUploadChange = ({target}) => {
        const files = target.files;
        processFile(files[0]);
    }

    const processFile = (fileToBeUploaded) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(fileToBeUploaded);
        fileReader.onload = () => {
            const name = fileToBeUploaded.name;
            const extension = "." + name.split(".").pop();
            const size = fileToBeUploaded.size;
            const data = fileReader.result.split("base64,").pop();
            const file = {name, extension, size, data, contextObjectReferenceVO: {externalReference: "1", contextId: "1"}};
            setFile(file);
        }
    }

    return (
        <div>
            <input ref={fileInputRef} className="file-upload-button-file-input" type="file"
                   onChange={handleFileUploadChange}/>
            <StandardButton text={buttonText} onClick={handleButtonClick} disabled={disableButton}/>
        </div>
    );
}
